import { supabase } from '@/supabase'

const env = import.meta.env.VITE_WEB_ENV
const secrets = {}

export async function initSecrets() {
  const { data } = await supabase
    .from('viu-api-keys')
    .select('key, value')
    .in('key', [
      `typesense_api_key_${env}`,
      `google_maps_api_key_${env}`,
      `timify_app_id_${env}`,
      `timify_app_secret_${env}`,
      `timify_api_secret_${env}`,
    ])

  data?.forEach(({ key, value }) => {
    secrets[key] = value
  })
}

export async function fetchSecretsLike(pattern) {
  const { data } = await supabase.from('viu-api-keys').select('key, value').like('key', pattern)

  data?.forEach(({ key, value }) => {
    secrets[key] = value
  })
}

export function getSecret(name) {
  return secrets[`${name}_${env}`]
}
